import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	ModalDialog,
	ModalHeader,
	ModalTitle,
	ModalBody,
	ModalFooter,
	StandardButton,
} from '@atlassian/jira-portfolio-3-common';
import commonMessages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';
import messages from './messages';
import type { Props } from './types';

function SavingDialog({ viewName, onConfirm, onClose }: Props) {
	const { formatMessage } = useIntl();

	return (
		<ModalDialog
			autoFocus
			shouldScrollInViewport
			onClose={onClose}
			shouldCloseOnOverlayClick
			shouldCloseOnEscapePress
		>
			<ModalHeader>
				<ModalTitle>{formatMessage(messages.heading, { viewName })}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				{formatMessage(messages.message, {
					viewName,
					strong: (chunks: React.ReactNode[]) => <strong>{chunks}</strong>,
				})}
			</ModalBody>
			<ModalFooter>
				<StandardButton appearance="subtle" onClick={onClose}>
					{formatMessage(commonMessages.cancel)}
				</StandardButton>
				<StandardButton
					appearance="primary"
					onClick={onConfirm}
					testId="portfolio-3-portfolio.app-simple-plans.top.view-bar.saving-dialog.view-save-changes-save-button"
				>
					{formatMessage(commonMessages.save)}
				</StandardButton>
			</ModalFooter>
		</ModalDialog>
	);
}

export default SavingDialog;
